export class ObjectHelper {
  static getFieldByString(object, stringKeys: string): any {
    return stringKeys.split('.').reduce((p, c) => p && p[c], object);
  }
}
